/* GENERATED FILE */
import { forwardRef } from "react";
import variants from "../defs/column-spacing";
import IconBase from "../lib/icon-base";
import type { Icon } from "../lib/types";

const I: Icon = forwardRef((props, ref) => (
	<IconBase ref={ref} {...props} variants={variants} />
));

I.displayName = "ColumnSpacing";
export { I as ColumnSpacing };
